interface Props {
  title?: string;
  description?: string;
}

export default function SettingSectionTitle({ title, description }: Props) {
  return (
    <>
      <h2 className="text-base font-semibold leading-7 text-gray-900">
        {title}
      </h2>
      <p className="mt-1 text-sm leading-6 text-gray-500">{description}</p>
    </>
  );
}
